import { createBrowserRouter } from 'react-router-dom';
import { AppRoot, LoginOkRoute } from '@/app/AppRoot';
import { AppLayout } from '@/app/layouts/AppLayout';
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage';
import { LiveFeedPage } from '@/features/live-feed/pages/LiveFeedPage';
import { ReportsPage } from '@/features/reports/pages/ReportsPage';
import { CallLogsPage } from '@/features/call-logs/pages/CallLogsPage';
import { SettingsPage } from '@/features/settings/pages/SettingsPage';
import { WarmTransferPage } from '@/features/warm-transfer/pages/WarmTransferPage';
import { NotFoundPage } from '@/features/shared/pages/NotFoundPage';
import { RouteErrorPage } from '@/features/shared/pages/RouteErrorPage';

export const router = createBrowserRouter([
  {
    element: <AppRoot />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: '/loginok',
        element: <LoginOkRoute />,
      },
      {
        path: '/',
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: 'live-feed',
            element: <LiveFeedPage />,
          },
          {
            path: 'warm-transfer',
            element: <WarmTransferPage />,
          },
          {
            path: 'reports',
            element: <ReportsPage />,
          },
          {
            path: 'call-logs',
            element: <CallLogsPage />,
          },
          {
            path: 'settings',
            element: <SettingsPage />,
          },
          {
            path: '*',
            element: <NotFoundPage />,
          },
        ],
      },
    ],
  },
]);
